import { render, staticRenderFns } from "./DistributionSpecial.vue?vue&type=template&id=45d29a00&scoped=true&"
import script from "./DistributionSpecial.vue?vue&type=script&lang=js&"
export * from "./DistributionSpecial.vue?vue&type=script&lang=js&"
import style0 from "./DistributionSpecial.vue?vue&type=style&index=0&id=45d29a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d29a00",
  null
  
)

export default component.exports